// extracted by mini-css-extract-plugin
export default {"input":"Input_input__ld5EO","error":"Input_error__5K1ff","textError":"Input_textError__F586J"};